import _ from 'lodash';
import {
  CREATE_STORYBOARD_LIST_REQUEST, CREATING_STORYBOARD_LIST_SUCCEEDED, CREATING_STORYBOARD_LIST_FAILED,
  FETCH_STORYBOARD_LIST_REQUEST, FETCHING_STORYBOARD_LIST_SUCCEEDED, FETCHING_STORYBOARD_LIST_FAILED,
  DELETE_STORYBOARD_LIST_REQUEST, DELETING_STORYBOARD_LIST_SUCCEEDED, DELETING_STORYBOARD_LIST_FAILED,
  UPDATING_STORYBOARD_LIST_REQUEST, UPDATING_STORYBOARD_LIST_SUCCEEDED, UPDATING_STORYBOARD_LIST_FAILED,
  SHOW_STORYBOARD_LIST_CREATE_FORM, INVALIDATE_STORYBOARD_LIST, SELECT_STORYBOARD_LIST,
  ADDING_STORYBOARD_TO_LIST_REQUEST, ADDING_STORYBOARD_TO_LIST_SUCCEEDED, ADDING_STORYBOARD_TO_LIST_FAILED,
  INVALIDATE_ADD_STORYBOARD
} from 'constants/actionTypes';

const initialState = {
  loading: false,
  creating: false,
  items: [],
  error: null,
  activeList: null,
  create: {
    creating: false,
    created: false,
    visible: false,
    error: null
  },
  addStoryboard: {
    id: null,
    adding: false,
    added: false,
    successMessage: null,
    error: null
  },
  item: {
    id: null,
    edit: {
      editing: false,
      edited: false,
      error: null
    },
    delete: {
      deleting: false,
      deleted: false,
      error: null
    }
  }
}

export function storyboardsListReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_STORYBOARD_LIST_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          visible: true,
          creating: true,
          error: null
        }
      }

    case CREATING_STORYBOARD_LIST_SUCCEEDED: {
      var items = [...state.items, action.payload];
      items = _.uniqBy(items, 'id');

      return {
        ...state,
        items: items,
        error: null,
        item: {
          ...state.item,
          id: action.payload.id
        },
        create: {
          ...state.create,
          creating: false,
          created: true,
          visible: false,
          error: null
        }
      }
    }

    case CREATING_STORYBOARD_LIST_FAILED: {
      var error = action.payload.error;

      return {
        ...state,
        create: {
          ...state.create,
          creating: false,
          created: true,
          visible: false,
          error: null
        }
      }
    }

    case FETCH_STORYBOARD_LIST_REQUEST: {
      return {
        ...state,
        loading: true
      }
    }

    case FETCHING_STORYBOARD_LIST_SUCCEEDED: {

      return {
        ...state,
        loading: false,
        error: null,
        items: action.payload,
      }
    }

    case FETCHING_STORYBOARD_LIST_FAILED: {
      var error = action.payload.error;

      return {
        ...state,
        loading: false,
        error: error
      }
    }

    case DELETE_STORYBOARD_LIST_REQUEST: {
      return {
        ...state,
        loading: true,
        item: {
          ...state.item,
          delete: {
            deleting: true,
            deleted: false,
            error: null
          }
        }
      }
    }

    case DELETING_STORYBOARD_LIST_SUCCEEDED: {

      var items = state.items.filter(item => {
        return item.id !== action.payload.id;
      })

      return {
        ...state,
        loading: false,
        items: items,
        error: null,
        item: {
          ...state.item,
          delete: {
            deleting: false,
            deleted: true,
            error: null
          }
        }
      }
    }

    case DELETING_STORYBOARD_LIST_FAILED: {
      var error = action.payload.error;

      return {
        ...state,
        loading: false,
        error: error,
        item: {
          ...state.item,
          delete: {
            deleting: false,
            deleted: false,
            error: null
          }
        }
      }
    }

    case UPDATING_STORYBOARD_LIST_REQUEST: {
      return {
        ...state,
        loading: true,
        creating: true,
        item: {
          ...state.item,
          edit: {
            ...state.item.edit,
            editing: true,
            edited: false,
            error: null
          }
        }
      }
    }

    case UPDATING_STORYBOARD_LIST_SUCCEEDED: {

      var items = _.map(state.items, function (item) {
        return item.id === action.payload.id ? action.payload : item;
      });

      return {
        ...state,
        loading: false,
        creating: false,
        items: items,
        error: null,
        item: {
          ...state.item,
          edit: {
            ...state.item.edit,
            editing: false,
            edited: true,
            error: null
          }
        }
      }
    }

    case UPDATING_STORYBOARD_LIST_FAILED: {
      var error = action.payload.error;
      return {
        ...state,
        item: {
          ...state.item,
          edit: {
            ...state.item.edit,
            editing: false,
            edited: false,
            error: error
          }
        }
      }
    }

    case SHOW_STORYBOARD_LIST_CREATE_FORM: {
      return {
        ...state,
        create: {
          visible: true,
          creating: false,
          created: false,
          error: null
        }
      }
    }

    case INVALIDATE_STORYBOARD_LIST: {
      return {
        ...state,
        error: null,
        create: {
          visible: false,
          creating: false,
          created: false,
          error: null
        },
        addStoryboard: {
          id: null,
          adding: false,
          added: false,
          error: null
        },
        item: {
          ...state.item,
          id: null,
          edit: {
            editing: false,
            edited: false,
            error: null
          },
          delete: {
            deleting: false,
            deleted: false,
            error: null
          }
        }
      }
    }

    case SELECT_STORYBOARD_LIST: {
      const { id } = action.payload;

      return {
        ...state,
        error: null,
        create: {
          visible: false,
          creating: false,
          created: false,
          error: null
        },
        item: {
          ...state.item,
          id: id,
          edit: {
            editing: false,
            edited: false,
            error: null
          },
          delete: {
            deleting: false,
            deleted: false,
            error: null
          }
        }
      }
    }

    case ADDING_STORYBOARD_TO_LIST_REQUEST: {
      return {
        ...state,
        addStoryboard: {
          ...state.addStoryboard,
          adding: true,
          added: false,
        }
      }
    }

    case ADDING_STORYBOARD_TO_LIST_SUCCEEDED: {
      var { target, storyboard } = action.payload;

      var successMessage = `Storyboard ${storyboard.name} added to ${target.name} Successfully`
      return {
        ...state,
        error: null,
        addStoryboard: {
          ...state.addStoryboard,
          id: target,
          adding: false,
          added: true,
          successMessage: successMessage
        }
      }
    }

    case ADDING_STORYBOARD_TO_LIST_FAILED: {
      var error = action.payload.error;

      return {
        ...state,
        addStoryboard: {
          ...state.addStoryboard,
          adding: false,
          added: false,
          error: error,
          successMessage: null
        }
      }
    }

    case INVALIDATE_ADD_STORYBOARD: {
      return {
        ...state,
        error: null,
        addStoryboard: {
          id: null,
          adding: false,
          added: false,
          successMessage: null,
          error: null
        }
      }
    }

    default:
      return state;
  }
}